import { CommonModule } from '@angular/common';
import { Component, ElementRef, Inject, PLATFORM_ID } from '@angular/core';
import { Firestore } from '@angular/fire/firestore';
import { ActivatedRoute, RouterModule } from '@angular/router';

import { LinkListModule } from '@yoimo/interfaces';
import {
  CardModule,
  CarouselModule,
  LinkCardListComponent,
} from '@yoimo/joymo-ui';
import { LinkCardListItem } from '@yoimo/joymo-ui';

import { combineLatest, shareReplay, switchMap, tap } from 'rxjs';

import { LibScopeService, PROVIDED } from 'shared-lib/core';

import { getResolvedLinkListItems$ } from './link-list.utils';
import { PageModuleDirective } from '../page-module.directive';

@Component({
  standalone: true,
  selector: 'joymo-link-list',
  templateUrl: './link-list.component.html',
  styleUrls: ['./link-list.component.scss'],
  imports: [
    CommonModule,
    CardModule,
    RouterModule,
    CarouselModule,
    LinkCardListComponent,
  ],
})
export class LinkListComponent extends PageModuleDirective<
  LinkListModule & { _id: string },
  LinkCardListItem
> {
  constructor(
    protected override fs: Firestore,
    protected override route: ActivatedRoute,
    @Inject(PROVIDED.scopeService)
    protected override scopeService: LibScopeService,
    @Inject(PLATFORM_ID)
    public override platformId: string,
    protected override element: ElementRef
  ) {
    super(fs, route, scopeService, platformId, element);
  }

  readonly channel$ = this.scopeService.listenToChannel();

  initOnServer(): void {}

  initOnBrowser(): void {
    this.$items = combineLatest([
      this.$scope,
      this.channel$,
      this.loadData$,
    ]).pipe(
      switchMap(([scope, channel, _]) => {
        return getResolvedLinkListItems$(
          this.fs,
          this.moduleData,
          scope,
          channel,
          this.homepageUrl ?? ''
        );
      }),
      tap((data) => {
        this.emitIfEmptyModule(data);
        setTimeout(() => {
          this.isLoading = false;
        });
      }),
      shareReplay(1)
    );
  }

  getLinkCardDensity(density: string): 'normal' | 'dense' {
    switch (density) {
      case 'NORMAL':
        return 'normal';
      case 'DENSE':
      case 'DENSEST':
        return 'dense';
      default:
        return 'normal';
    }
  }

  getLayoutType(layoutType: string): 'carousel' | 'grid' {
    switch (layoutType) {
      case 'GRID':
        return 'grid';
      case 'CAROUSEL':
      default:
        return 'carousel';
    }
  }
}
